var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarrot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8862 11.4781C12.8862 11.4781 10.484 2.72455 15.855 0.398387C19.1623 5.04987 12.8862 11.4781 12.8862 11.4781Z",
    fill: "#6B42DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0589 7.66897C23.0589 7.66897 14.3053 5.26677 11.9792 10.6378C16.6307 13.945 23.0589 7.66897 23.0589 7.66897Z",
    fill: "#6B42DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0051 3.49478C20.0051 3.49478 11.2231 5.79121 11.8941 11.6057C17.576 12.1441 20.0051 3.49478 20.0051 3.49478Z",
    fill: "#6B42DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.57941 17.5135L2.86924 17.8033C3.25976 18.1938 3.89293 18.1938 4.28345 17.8033C4.67398 17.4128 4.67398 16.7796 4.28345 16.3891L3.59229 15.6979L4.60517 13.8824L5.69767 14.9749C6.08819 15.3654 6.72136 15.3654 7.11188 14.9749C7.5024 14.5844 7.5024 13.9512 7.11188 13.5607L5.69767 12.1465C5.67117 12.12 5.64355 12.0953 5.61497 12.0724L6.63093 10.2513L8.52609 12.1465C8.91662 12.537 9.54978 12.537 9.94031 12.1465C10.3308 11.7559 10.3308 11.1228 9.94031 10.7322L7.81899 8.61092C7.7606 8.55253 7.6968 8.50288 7.62919 8.46195L7.87373 8.02362C8.41188 7.05901 9.6301 6.7133 10.5947 7.25145C10.756 7.3414 10.904 7.45325 11.0345 7.58381L15.9172 12.4665C16.6983 13.2476 16.6983 14.5139 15.9172 15.2949C15.7867 15.4255 15.6386 15.5373 15.4774 15.6273L3.46972 22.3263C2.81102 22.6938 1.98841 22.5793 1.45506 22.046C0.921702 21.5126 0.80724 20.69 1.17473 20.0313L2.57941 17.5135Z",
    fill: "#6B42DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrot);
export default __webpack_public_path__ + "static/media/carrot.025e6b6286966659ef5c450bfd98348e.svg";
export { ForwardRef as ReactComponent };